import { ReactElement, useContext } from 'react'

import {
  FieldValues,
  useFormContext,
  UseFormSetValue,
  useWatch
} from 'react-hook-form'
import { CustomContext } from './CustomProvider'

export function Data<T extends FieldValues>({
  children
}: {
  children: (
    values: T,
    props: { setValue: UseFormSetValue<T>; readOnly: boolean }
  ) => ReactElement | null
}) {
  const { setValue } = useFormContext<T>()
  const { readOnly } = useContext(CustomContext)
  const values = useWatch<T>()

  return children(values as T, { setValue, readOnly })
}
